import React from 'react';
import {
    Container,
    Navbar,
    Nav,
    NavLink,
} from 'react-bootstrap';
import Logo from '../assets/logo/bba_log.svg'
import '../styles/Navbar.css'
import ContactButton from "./ContactButton";


const Navi = (props) => {
    return (
        <div className="center">
            <Container>
                <Navbar bg="" variant="dark" expand="lg" style={{paddingVertical: '5%'}}>
                    <Navbar.Brand href="/">
                        <img
                            alt=""
                            src={Logo}
                            width="120"
                            height="120"
                        />{''}
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="ms-auto align-items-center">
                            <NavLink style={{color: '#fff'}} href="/about">Hakkımızda</NavLink>
                            <NavLink style={{color: '#fff'}} href="/services">Servislerimiz</NavLink>
                            <NavLink>
                                <ContactButton/>
                            </NavLink>
                            <a href="https://www.instagram.com/balikesirbakiciajansi?igsh=MTN1NjJ2eDl4ZnFtZQ==" className="ins-ic nav-link">
                                <i className="fab fa-instagram" />
                            </a>
                            <a href="https://www.facebook.com/share/16P6CmnPhG/" className="fb-ic nav-link">
                                <i className="fab fa-facebook-f" />
                            </a>
                            <a href="https://www.linkedin.com/company/balikesirkbdanismanlik" className="li-ic nav-link">
                                <i className="fab fa-linkedin-in" />
                            </a>
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>
            </Container>
        </div>
    );
}

export default Navi;
